import * as React from 'react';
import { useContext } from 'react';
import { Money } from '../../../types';
import PriceBlock from './PriceBlock/PriceBlock';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import { BaggageContext } from '../../context';
import { default as BaseButton } from '../../../BaseComponents/Button';

interface Props {
	min?: Money;
	total?: Money;
	onClickButton?: React.MouseEventHandler<HTMLButtonElement>;
}

const BaggageTotalPriceBlock: React.FC<Props> = ({ min, total, onClickButton }) => {
	const { BaggageTotalPriceBlock: css } = useTheme('BaggageTotalPriceBlock');
	const { t } = useTranslation('AdditionalBaggage');
	const isReadOnly = useContext(BaggageContext)?.isReadOnly;
	const edit = total?.amount !== undefined;

	return (
		<div className={css.root}>
			<PriceBlock className={css.price} total={total} min={min} />

			<BaseButton
				className={cn(css.control, {
					[css.control__edit]: edit && !isReadOnly
				})}
				onClick={onClickButton}
				variant={edit ? 'optionEdit' : 'optionAction'}
			>
				{isReadOnly ? t('Checkout:More details') : t(edit ? 'Edit' : 'Add')}
			</BaseButton>
		</div>
	);
};

export default BaggageTotalPriceBlock;
